import {
  configApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { SignInPage } from '@backstage/core-components';
import { createApp } from '@backstage/frontend-defaults';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import visualizerPlugin from '@backstage/plugin-app-visualizer';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import githubActionsPlugin from '@backstage-community/plugin-github-actions/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import techInsightsPlugin from '@backstage-community/plugin-tech-insights/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import { myralisHomePlugin } from './modules/home';
import { customCatalogPlugin } from './modules/catalog';
import { githubActionsAuthModule } from './modules/githubActions';
import { cloudbuildModule } from './modules/cloudbuild';
import { navModule } from './modules/nav';
import { i18nModule } from './modules/i18n';
import { cloudrunHealthModule } from './modules/cloudrunHealth';

const microsoftProvider = {
  id: 'microsoft-auth-provider',
  title: 'Microsoft Entra',
  message: 'Entrar com a conta corporativa',
  apiRef: microsoftAuthApiRef,
};

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => {
      const configApi = useApi(configApiRef);
      const authEnvironment = configApi.getOptionalString('auth.environment');
      const hasMicrosoftProvider = configApi.has('auth.providers.microsoft');

      if (authEnvironment === 'development' || !hasMicrosoftProvider) {
        return (
          <div className="myralis-sign-in-page">
            <SignInPage
              {...props}
              providers={hasMicrosoftProvider ? ['guest', microsoftProvider] : ['guest']}
            />
          </div>
        );
      }

      return (
        <div className="myralis-sign-in-page">
          <SignInPage {...props} provider={microsoftProvider} />
        </div>
      );
    },
  },
});

export default createApp({
  features: [
    customCatalogPlugin,
    catalogImportPlugin,
    myralisHomePlugin,
    searchPlugin,
    techdocsPlugin,
    apiDocsPlugin,
    scaffolderPlugin,
    userSettingsPlugin,
    catalogGraphPlugin,
    visualizerPlugin,
    githubActionsPlugin,
    githubActionsAuthModule,
    cloudbuildModule,
    techInsightsPlugin,
    cloudrunHealthModule,
    navModule,
    i18nModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
